import { apiV2Root } from "consts";
import type { Menu } from "features/menu/types";
import { MENUS_QUERY_KEY } from "features/menu/types";
import { useDataQueryParams } from "hooks/useDataQueryParams";

export const useMenus = (): Menu[] | undefined =>
  useDataQueryParams<Menu[]>(MENUS_QUERY_KEY, {}, apiV2Root);

export const useMenu = (slug: string): Menu | undefined => {
  const menus = useMenus();

  return menus?.find((menu) => menu.slug === slug);
};
